<template>
  <b-container data-app fluid>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title title-typography-color">
          <i class="fas fa-search"></i>
          {{
            $t(
              "public.views.Pages.Professional.Admin.Payments.tab.plataform.search.title"
            )
          }}
        </h4>
      </template>
      <template v-slot:body>
        <b-row>
          <b-col lg="3" md="3" sm="6" xl="3">
            <b-form-group label-for="professionals">
              <template slot="label">{{
                $t(
                  "public.views.Pages.Professional.Admin.Payments.filters.professionals"
                )
              }}:
              </template>
              <multiselect v-model="filter.professionals" :clear-on-select="false" :close-on-select="false"
                :multiple="true" :options="professionalsFilterSelect" :preselect-first="true" :preserve-search="true"
                label="text" track-by="value" v-bind:deselectGroupLabel="$t(
                  'public.views.Pages.Professional.Admin.Payments.multiselect.deselectGroupLabel'
                )
                  " v-bind:deselectLabel="$t(
    'public.views.Pages.Professional.Admin.Payments.multiselect.deselectLabel'
  )
    " v-bind:placeholder="$t(
    'public.views.Pages.Professional.Admin.Payments.multiselect.placeholder2'
  )
    " v-bind:selectGroupLabel="$t(
    'public.views.Pages.Professional.Admin.Payments.multiselect.selectGroupLabel'
  )
    " v-bind:selectLabel="$t(
    'public.views.Pages.Professional.Admin.Payments.multiselect.selectLabel'
  )
    " v-bind:selectedLabel="$t(
    'public.views.Pages.Professional.Admin.Payments.multiselect.selectedLabel'
  )
    " @input="changeFilter">
                <template slot="option" slot-scope="props">
                  <b-list-group-item class="d-flex align-items-center">
                    <b-avatar class="mr-3" v-bind:src="props.option.avatar"></b-avatar>
                    <span class="mr-auto title-typography-color">{{
                      props.option.text
                    }}</span>
                  </b-list-group-item>
                </template>
                <template slot="selection" slot-scope="{ values, isOpen }"><span v-if="values.length && !isOpen"
                    class="multiselect__single">{{ values.length }}
                    {{
                      $t(
                        "public.views.Pages.Professional.Admin.Payments.selectedProfessionals"
                      )
                    }}</span></template>
              </multiselect>
            </b-form-group>
          </b-col>
          <b-col lg="3" md="3" sm="6" xl="3">
            <b-form-group label-for="patients">
              <template slot="label">{{
                $t(
                  "public.views.Pages.Professional.Admin.Payments.filters.patients"
                )
              }}:
              </template>
              <multiselect v-model="filter.patients" :clear-on-select="false" :close-on-select="false"
                :loading="isLoadingPatients" :multiple="true" :options="patientsFilterSelect" :preselect-first="true"
                :preserve-search="true" label="text" track-by="value" v-bind:deselectGroupLabel="$t(
                  'public.views.Pages.Professional.Admin.Payments.multiselect.deselectGroupLabel'
                )
                  " v-bind:deselectLabel="$t(
    'public.views.Pages.Professional.Admin.Payments.multiselect.deselectLabel'
  )
    " v-bind:placeholder="$t(
    'public.views.Pages.Professional.Admin.Payments.multiselect.placeholder'
  )
    " v-bind:selectGroupLabel="$t(
    'public.views.Pages.Professional.Admin.Payments.multiselect.selectGroupLabel'
  )
    " v-bind:selectLabel="$t(
    'public.views.Pages.Professional.Admin.Payments.multiselect.selectLabel'
  )
    " v-bind:selectedLabel="$t(
    'public.views.Pages.Professional.Admin.Payments.multiselect.selectedLabel'
  )
    " @input="changeFilter" @search-change="getAllPatients">
                <template slot="noResult">
                  {{ $t("generic.noResults") }}
                </template>
                <template slot="noOptions">
                  {{ $t("generic.min3") }}
                </template>
                <template slot="option" slot-scope="props">
                  <b-list-group-item class="d-flex align-items-center">
                    <b-avatar class="mr-3" v-bind:src="props.option.avatar"></b-avatar>
                    <span class="mr-auto title-typography-color">{{
                      props.option.text
                    }}</span>
                  </b-list-group-item>
                </template>
                <template slot="selection" slot-scope="{ values, isOpen }"><span v-if="values.length && !isOpen"
                    class="multiselect__single">{{ values.length }}
                    {{
                      $t(
                        "public.views.Pages.Professional.Admin.Payments.selectedContacts"
                      )
                    }}</span></template>
              </multiselect>
            </b-form-group>
          </b-col>
          <b-col lg="3" md="3" sm="6" xl="3">
            <b-form-group label-for="dateAtStart">
              <template slot="label">{{
                $t(
                  "public.views.Pages.Professional.Admin.Payments.filters.dateAtStart"
                )
              }}:
              </template>
              <date-picker v-model="filter.startTo" :format="myFormat" :formatter="momentFormat" class="w-100" type="date"
                @input="changeFilter"></date-picker>
            </b-form-group>
          </b-col>
          <b-col lg="3" md="3" sm="6" xl="3">
            <b-form-group label-for="dateAtEnd">
              <template slot="label">{{
                $t(
                  "public.views.Pages.Professional.Admin.Payments.filters.dateAtEnd"
                )
              }}:
              </template>
              <date-picker v-model="filter.startFrom" :format="myFormat" :formatter="momentFormat" class="w-100"
                type="date" @input="changeFilter"></date-picker>
            </b-form-group>
          </b-col>

          <b-col lg="3" md="3" sm="6" xl="3">
            <b-form-group label-for="price">
              <template slot="label">
                {{
                  $t(
                    "public.views.Pages.Professional.Admin.Payments.filters.price"
                  )
                }}:
              </template>
              <b-input v-model="filter.price" type="number" @input="changeFilter"></b-input>
            </b-form-group>
          </b-col>
          <b-col lg="3" md="3" sm="6" xl="3">
            <b-form-group label-for="paid">
              <template slot="label">
                {{
                  $t(
                    "public.views.Pages.Professional.Admin.Payments.filters.paid"
                  )
                }}:
              </template>
              <b-form-select v-model="filter.paid" :options="paidSelect" @input="changeFilter">
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col lg="3" md="3" sm="6" xl="3">
            <b-form-group label-for="paymentType">
              <template slot="label">
                {{
                  $t(
                    "public.views.Pages.Professional.Admin.Payments.filters.paymentType"
                  )
                }}:
              </template>
              <b-form-select v-model="filter.paymentType" :options="paymentTypeSelect" @input="changeFilter">
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col lg="3" md="3" sm="6" xl="3">
            <b-form-group>
              <b-form-checkbox v-model="filter.canceled" @change="changeFilter">
                {{ $t("public.views.Pages.Professional.Admin.Payments.filters.canceled") }}
              </b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>
      </template>
    </iq-card>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title title-typography-color">
          <i class="fas fa-money-bill-wave"></i>
          {{
            $t("public.views.Pages.Professional.Admin.Payments.managementPay")
          }}
        </h4>
      </template>
      <template v-slot:body>
        <span class="badge badge-success mr-2">{{ $t("public.views.Pages.Professional.Admin.Payments.totalPay") }}:
          {{ totalPaid.toFixed(2) }} €</span>
        <span class="badge badge-danger">{{
          $t("public.views.Pages.Professional.Admin.Payments.totalPending")
        }}: {{ totalPending.toFixed(2) }} €
        </span>
        <div class="text-right">
          <b-button class="mb-3 mr-1" variant="secondary" @click="getEventsPayExcel">
            Excel
          </b-button>
        </div>
        <div>
          <v-data-table :footer-props="{
            showFirstLastPage: true,
            firstIcon: 'fas fa-arrow-left',
            lastIcon: 'fas fa-arrow-right',
            prevIcon: 'fas fa-minus',
            nextIcon: 'fas fa-plus',
            'items-per-page-options': [10, 25, 50],
          }" :headers="headers" :items="eventsPlataform" :options.sync="pagination" :server-items-length="total"
            item-key="name">
            <template v-slot:item.professionalLead="{ item }">
              <b-list-group-item v-if="item.professionalLead" class="d-flex align-items-center border-0 p-0">
                <b-avatar v-bind:src="item.professionalLead.avatarUrl
                    ? item.professionalLead.avatarUrl +
                    '/' +
                    getAuthentication()
                    : ''
                  "></b-avatar>
                <div class="media-support-info ml-3">
                  <p class="mb-0 font-size-16">
                    {{ item.professionalLead.name }}
                  </p>
                  <p class="mb-0 font-size-12">
                    {{ item.professionalLead.lastname }}
                  </p>
                </div>
              </b-list-group-item>
            </template>
            <template v-slot:item.patients="{ item }">
              <b-list-group-item v-if="item.patient" class="d-flex align-items-center border-0 p-0">
                <b-avatar v-bind:src="item.patient.avatarUrl
                    ? item.patient.avatarUrl +
                    '/' +
                    getAuthentication()
                    : ''
                  "></b-avatar>
                <div class="media-support-info ml-3">
                  <p class="mb-0 font-size-16">{{ item.patient.name }}</p>
                  <p class="mb-0 font-size-12">{{ item.patient.lastname }}</p>
                </div>
              </b-list-group-item>
            </template>
            <template v-slot:item.date="{ item }">
              {{ new Date(item.startedAt).toLocaleString() }}
            </template>
            <template v-slot:item.price="{ item }">
              <span> {{ item.price.toFixed(2) }} € </span>
            </template>
            <template v-slot:item.payment="{ item }">
              <span v-if="item.payment" class="badge badge-success text-uppercase">{{ $t("generic.yes") }}</span>
              <span v-else class="badge badge-danger text-uppercase">
                {{ $t("generic.no") }}</span>
            </template>
            <template v-slot:item.visitType="{ item }">
              <div v-if="item.payment">
                {{ $t("generic.payment.mode." + item.payment.paymentMode) }}
                <span v-if="item.payment.paymentMode === 'OUT_PLATAFORM' &&
                  item.payment.paymentOutPlataform
                  ">
                  ({{ item.payment.paymentOutPlataform.name }})</span>
              </div>
            </template>
            <template v-slot:item.actions="{ item, index }">
              <div class="div-table-data">
                <div v-if="item.invoices && item.invoices.length !== 0">
                  <button :id="'btnDownloadInvoicePlataform' + index" class="item"
                    v-on:click="downloadInvoicePlataform(item.invoices)">
                    <i class="ri-file-download-line"></i>
                  </button>
                  <b-popover :target="'btnDownloadInvoicePlataform' + index" placement="botton" triggers="hover focus">
                    <template #title>{{
                      $t(
                        "public.views.Pages.Professional.Admin.Payments.tab.plataform.btnDownloadInvoice"
                      )
                    }}
                    </template>
                  </b-popover>
                </div>
                <div v-else>
                  <button :id="'btnGenerateInvoicePlataform' + index" class="item" v-on:click="
                    generateInvoicePlataform(item.eventId, item.patient.id)
                    ">
                    <i class="ri-file-pdf-line"></i>
                  </button>
                  <b-popover :target="'btnGenerateInvoicePlataform' + index" placement="botton" triggers="hover focus">
                    <template #title>{{
                      $t(
                        "public.views.Pages.Professional.Admin.Payments.tab.plataform.btnGenerateInvoice"
                      )
                    }}
                    </template>
                  </b-popover>
                </div>
                <div v-if="item.invoices && item.invoices.length !== 0">
                  <button :id="'btnSendInvoicePlataform' + index" class="item"
                    v-on:click="sendInvoicePlataform(item.invoices)">
                    <i class="ri-mail-send-line"></i>
                  </button>
                  <b-popover :target="'btnSendInvoicePlataform' + index" placement="botton" triggers="hover focus">
                    <template #title>{{
                      $t(
                        "public.auth.professional.admin.payments.tab.plataform.btnSendInvoice"
                      )
                    }}
                    </template>
                  </b-popover>
                </div>

                <div>
                  <button :id="'btnChangeOutPlataform' + index" class="item" v-on:click="
                    changeOutPlataform(item.eventId, item.patient.id)
                    ">
                    <i class="ri-bank-card-line"></i>
                  </button>
                  <b-popover :target="'btnChangeOutPlataform' + index" placement="botton" triggers="hover focus">
                    <template #title>{{
                      $t(
                        "public.views.Pages.Professional.Admin.Payments.tab.plataform.btnChangeOutPlataform"
                      )
                    }}
                    </template>
                  </b-popover>
                </div>
              </div>
            </template>
          </v-data-table>
        </div>
      </template>
    </iq-card>

    <b-modal id="modal-check-paid-professional" centered hide-footer size="lg">
      <template #modal-title>
        {{ $t("public.views.Pages.Professional.Admin.Payments.markPaid") }}
      </template>
      <div class="payment-btn-center">
        <div v-for="(item, index) in paymentOutPlataforms" :key="index">
          <b-button v-if="item.active" class="mr-2" variant="success" @click="putPaymentOutPlataformAndPay(item.id)">
            {{ item.name }}
          </b-button>
        </div>
        <div>
          <b-button class="mr-2" variant="success" @click="walletPayment">
            {{ $t("public.views.Pages.Professional.Admin.Payments.btnWallet") }}
          </b-button>
        </div>
      </div>
      <div class="payment-btn-center mt-2">
        <b-button class="mr-2" variant="danger" @click="unpayEvent">
          {{ $t("public.views.Pages.Professional.Admin.Payments.btnNoPaid") }}
        </b-button>
      </div>
    </b-modal>
    <notifications group="notificacions" />
  </b-container>
</template>
<script>
import { xray } from "../../../../config/pluginInit";

import { mapActions, mapGetters } from "vuex";

import { saveAs } from "file-saver";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/es";

import moment from "moment";

import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";

import scheduleService from "../../../../services/schedule";
import organizationService from "../../../../services/organization";
import invoiceService from "../../../../services/invoice";
import patientService from "../../../../services/patient";
import professionalService from "../../../../services/professional";
import userService from "../../../../services/user";
import utilsService from "../../../../services/utils";

import PaymentOrNotFilterSelect from "../../../../json/filter/PaymentOrNotFilterSelect";
import PaymentTypeFilterSelect from "../../../../json/filter/PaymentTypeFilterSelect";

export default {
  name: "Payment",
  computed: {
    ...mapGetters({
      selectedUser: "Setting/userState",
    }),
  },
  mounted() {
    xray.index();
    this.getAllEventPlataform();
    this.getUser();
    this.getAllProfessionals();
    this.findAllPaymentOutPlataform(localStorage.getItem("organizationId"));
    this.paymentTypeSelectGenerate();
    utilsService.auditActivity({ action: "VIEW", module: "PROFESSIONAL_PAYMENTS", info: "" });
  },
  methods: {
    getAuthentication() {
      return localStorage.getItem('authorization');
    },
    getEventsPayExcel() {
      let data = this.cloneFilterSend();

      this.$awn.asyncBlock(
        scheduleService.getEventsPayExcel(data),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "VIEW", module: "PROFESSIONAL_PAYMENTS_EXCEL", info: "" });
            saveAs(response.data, "gestion_de_cobros.xlsx");
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "scheduleService.getEventsPayExcel",
            module: "view-pages-professional-admin-payments",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              data: data
            })
          });
        },
        " "
      );
    },
    checkPermissionProfessional(permission, permissionType) {
      return utilsService.checkPermissionProfessional(
        permission,
        permissionType
      );
    },
    async getUser() {
      let self = this;

      userService
        .get(localStorage.getItem("userId"))
        .then((response) => {
          if (response) {
            self.user = response.data;
          }
        })
        .catch((error) => {
          utilsService.auditErrorFrontent({
            info: "userService.get",
            module: "view-pages-professional-admin-payments",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              userId: localStorage.getItem("userId")
            })
          });
        });
    },
    changeFilter() {
      this.pageSize = 10;
      this.currentPage = 1;
      this.getAllEventPlataform();
    },
    getPlataform(eventId) {
      this.$router.push({
        name: "auth.professional.event",
        query: { eventId: eventId },
      });
    },
    downloadAbonoPlataform(id) {
      this.downloadInvoice(id);
    },
    generateAbonoPlataform(id) {
      this.downloadInvoice(id);
    },
    downloadInvoicePlataform(invoices) {
      let last = null;
      if (invoices && invoices.length !== 0) {
        invoices.forEach(function (invoice) {
          if (last === null) {
            last = invoice;
          } else {
            if (last.id < invoice.id) {
              last = invoice;
            }
          }
        });
      }
      this.downloadInvoice(last.id);
    },
    sendInvoicePlataform(invoices) {
      let last = null;
      if (invoices && invoices.length !== 0) {
        invoices.forEach(function (invoice) {
          if (last === null) {
            last = invoice;
          } else {
            if (last.id < invoice.id) {
              last = invoice;
            }
          }
        });
      }
      this.sendInvoice(last.id);
    },
    generateInvoicePlataform(id, patientId) {
      this.generateInvoice(id, patientId);
    },
    changeOutPlataform(id, patientId) {
      let self = this;

      this.eventId = id;
      this.patientId = patientId;

      this.$bvModal.show("modal-check-paid-professional");
    },
    putPaymentOutPlataformAndPay(id) {
      let self = this;
      self.$awn.asyncBlock(
        scheduleService.putPaymentOutPlataformAndPay(
          this.eventId,
          this.patientId,
          id
        ),
        (response) => {
          if (response) {
            self.getAllEventPlataform();
            self.$bvModal.hide("modal-check-paid-professional");
            self.$notify({
              group: "notificacions",
              title: self.$i18n.t(
                "public.views.Pages.Professional.Admin.Payments.tab.plataform.notification.changePaymentPlace.title"
              ),
              text: self.$i18n.t(
                "public.views.Pages.Professional.Admin.Payments.tab.plataform.notification.changePaymentPlace.desc"
              ),
              type: "success",
            });
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "scheduleService.putPaymentOutPlataformAndPay",
            module: "view-pages-professional-admin-payments",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              eventId: this.eventId,
              patientId: this.patientId,
              id: id
            })
          });
        },
        " "
      );
    },
    //Invoice
    downloadInvoice(invoiceId) {
      let self = this;

      this.$awn.asyncBlock(
        invoiceService.generatePdfInvoiceEvent(invoiceId),
        (response) => {
          if (response) {
            var byteCharacters = atob(response.data.data);
            var byteNumbers = new Array(byteCharacters.length);
            for (var i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);
            var file = new Blob([byteArray], {
              type: "application/pdf;base64",
            });
            var fileURL = URL.createObjectURL(file);

            var fileLink = document.createElement("a");

            fileLink.href = fileURL;
            fileLink.setAttribute("download", "factura.pdf");
            document.body.appendChild(fileLink);

            fileLink.click();
            this.$notify({
              group: "notificacions",
              title: self.$i18n.t(
                "public.views.Pages.Professional.Admin.Payments.notification.title"
              ),
              text: self.$i18n.t(
                "public.views.Pages.Professional.Admin.Payments.notification.descGeneratedInvoice"
              ),
              type: "success",
            });
            this.$bvModal.hide("modal-cita");
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "invoiceService.generatePdfInvoiceEvent",
            module: "view-pages-professional-admin-payments",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              invoiceId: invoiceId
            })
          });
        },
        " "
      );
    },
    sendInvoice(invoiceId) {
      let self = this;

      this.$awn.asyncBlock(
        invoiceService.sendPdfInvoiceEvent(invoiceId),
        (response) => {
          if (response) {
            self.$notify({
              group: "notificacions",
              title: self.$i18n.t(
                "public.views.Pages.Professional.Admin.Payments.notification.title"
              ),
              text: self.$i18n.t(
                "public.views.Pages.Professional.Admin.Payments.notification.descSendInvoice"
              ),
              type: "success",
            });
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "invoiceService.sendPdfInvoiceEvent",
            module: "view-pages-professional-admin-payments",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              invoiceId: invoiceId
            })
          });
        },
        " "
      );
    },
    generateInvoice(id, patientId) {
      let self = this;

      this.$awn.asyncBlock(
        scheduleService.generateInvoice(id, patientId),
        (response) => {
          if (response) {
            self.getAllEventPlataform();
            self.$notify({
              group: "notificacions",
              title: self.$i18n.t(
                "public.views.Pages.Professional.Admin.Payments.notification.title"
              ),
              text: self.$i18n.t(
                "public.views.Pages.Professional.Admin.Payments.notification.descCreated"
              ),
              type: "success",
            });
            self.$bvModal.hide("modal-cita");
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "scheduleService.generateInvoice",
            module: "view-pages-professional-admin-payments",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              id: id, patientId: patientId
            })
          });
        },
        " "
      );
    },
    //Abono
    downloadAbono(abonoId) {
      let self = this;

      this.$awn.asyncBlock(
        abonoService.generatePdfAbonoEvent(abonoId),
        (response) => {
          if (response) {
            var byteCharacters = atob(response.data.data);
            var byteNumbers = new Array(byteCharacters.length);
            for (var i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);
            var file = new Blob([byteArray], {
              type: "application/pdf;base64",
            });
            var fileURL = URL.createObjectURL(file);

            var fileLink = document.createElement("a");

            fileLink.href = fileURL;
            fileLink.setAttribute("download", "abono.pdf");
            document.body.appendChild(fileLink);

            fileLink.click();
            this.$notify({
              group: "notificacions",
              title: self.$i18n.t(
                "public.views.Pages.Professional.Admin.Payments.notification.title"
              ),
              text: self.$i18n.t(
                "public.views.Pages.Professional.Admin.Payments.notification.descCreatedPayment"
              ),
              type: "success",
            });
            this.$bvModal.hide("modal-cita");
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "abonoService.generatePdfAbonoEvent",
            module: "view-pages-professional-admin-payments",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              abonoId: abonoId
            })
          });
        },
        " "
      );
    },
    async findAllPaymentOutPlataform(organizationId) {
      let self = this;

      organizationService
        .getAllPaymentOutPlataform(organizationId)
        .then((response) => {
          if (response) {
            self.paymentOutPlataforms = response.data;
          }
        })
        .catch((error) => {
          utilsService.auditErrorFrontent({
            info: "organizationService.getAllPaymentOutPlataform",
            module: "view-pages-professional-admin-payments",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              organizationId: organizationId
            })
          });
        });
    },
    cloneFilterSend() {
      let clone = JSON.parse(JSON.stringify(this.filter));

      //Professionals

      if (clone.professionals) {
        let professionalREST = [];
        clone.professionals.forEach(function (professional) {
          professionalREST.push(professional.value);
        });
        clone.professionals = professionalREST;
      } else {
        clone.professionals = [];
      }

      //Patients

      if (clone.patients) {
        let patientsREST = [];
        clone.patients.forEach(function (patient) {
          patientsREST.push(patient.value);
        });
        clone.patients = patientsREST;
      } else {
        clone.patients = [];
      }

      // StartAt
      if (clone.startTo) {
        clone.startTo = moment(clone.startTo)
          .set("hour", 0)
          .set("minute", 0)
          .set("second", 0)
          .set("millisecond", 0);
      } else {
        clone.startTo = null;
      }

      if (clone.startFrom) {
        clone.startFrom = moment(clone.startFrom)
          .set("hour", 24)
          .set("minute", 0)
          .set("second", 0)
          .set("millisecond", 0);
      } else {
        clone.startFrom = null;
      }

      //Price
      if (clone.price) {
        clone.price = clone.price;
      } else {
        clone.price = null;
      }

      //Paid

      if (clone.paid) {
        if (clone.paid === "ALL") {
          clone.paid = null;
        } else if (clone.paid === "NO_PAYMENT") {
          clone.paid = false;
        } else if (clone.paid === "PAYMENT") {
          clone.paid = true;
        } else {
          clone.paid = null;
        }
      } else {
        clone.paid = null;
      }
      //PaymentType
      if (clone.paymentType) {
        if (clone.paymentType === "ALL") {
          clone.paymentType = null;
        } else if (
          clone.paymentType &&
          clone.paymentType.includes("PAYMENT_OUT_PLATAFORM")
        ) {
          clone.paymentOutPlataform = clone.paymentType.split("-").pop();
          clone.paymentType = "PAYMENT_OUT_PLATAFORM";
        } else {
          clone.paymentType = clone.paymentType;
        }
      } else {
        clone.paymentType = null;
      }

      return clone;
    },
    async getAllEventPlataform() {
      let self = this;

      let data = this.cloneFilterSend();

      this.$awn.asyncBlock(
        scheduleService.getAllEventPlataform(
          this.pagination.page - 1,
          this.pagination.itemsPerPage,
          data
        ),
        (response) => {
          if (response) {
            self.eventsPlataform = response.data.content;
            self.total = response.data.pageable.total;
            self.totalPaid = response.data.totalPaid;
            self.totalPending = response.data.totalNotPaid;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "scheduleService.getAllEventPlataform",
            module: "view-pages-professional-admin-payments",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              page: this.pagination.page - 1,
              itemsPerPage: this.pagination.itemsPerPage,
              data: data
            })
          });
        },
        " "
      );
    },
    async getAllPatients(query) {
      let self = this;

      if (query.length > 2) {
        this.isLoadingPatients = true;
        patientService
          .getAll(query)
          .then((response) => {
            let combo = [];
            response.data.forEach(function (item) {
              let data = {
                avatar: item.avatarUrl
                  ? item.avatarUrl + "/" + localStorage.getItem("authorization")
                  : "",
                uuid: item.uuid,
                value: item.id,
                text:
                  item.name + " " + item.lastname + " (" + item.document + ") ",
              };
              combo.push(data);
            });
            self.patientsFilterSelect = combo;
            self.isLoadingPatients = false;
          })
          .catch((error) => {
            utilsService.auditErrorFrontent({
              info: "patientService.getAll",
              module: "view-pages-professional-admin-payments",
              httpStatus: error.response ? error.response.status : null,
              endpoint: window.location.href,
              request: JSON.stringify({
                query: query
              })
            });
            self.isLoadingPatients = false;
          });
      }
    },
    async getAllProfessionals() {
      let self = this;

      professionalService
        .getAll()
        .then((response) => {
          let combo = [];
          response.data.forEach(function (item) {
            let data = {
              avatar: item.avatarUrl
                ? item.avatarUrl + "/" + localStorage.getItem("authorization")
                : "",
              uuid: item.uuid,
              value: item.id,
              text:
                item.name + " " + item.lastname + " (" + item.document + ") ",
            };
            combo.push(data);
          });
          self.professionalsFilterSelect = combo;
        })
        .catch((error) => {
          utilsService.auditErrorFrontent({
            info: "professionalService.getAll",
            module: "view-pages-professional-admin-payments",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: null
          });
        });
    },
    async paymentTypeSelectGenerate() {
      this.getAllPaymentOutPlataform();
    },
    async getAllPaymentOutPlataform() {
      let self = this;

      organizationService
        .getAllPaymentOutPlataform(localStorage.getItem("organizationId"))
        .then((response) => {
          if (response) {
            self.paymentTypeSelect = [];
            self.paymentTypeSelect = JSON.parse(
              JSON.stringify(PaymentTypeFilterSelect)
            );
            response.data.forEach(function (payment) {
              self.paymentTypeSelect.push({
                value: "PAYMENT_OUT_PLATAFORM-" + payment.id,
                text: payment.name,
              });
            });
          }
        })
        .catch((error) => {
          utilsService.auditErrorFrontent({
            info: "organizationService.getAllPaymentOutPlataform",
            module: "view-pages-professional-admin-payments",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              organizationId: localStorage.getItem("organizationId")
            })
          });
        });
    },
    unpayEvent() {
      let self = this;

      this.$swal({
        text: this.$i18n.t(
          "public.views.Pages.Professional.Admin.Payments.tab.plataform.confirm.nopay.text"
        ),
        showCancelButton: true,
        confirmButtonText: this.$i18n.t(
          "public.views.Pages.Professional.Admin.Payments.tab.plataform.confirm.nopay.btnConfirm"
        ),
        cancelButtonText: this.$i18n.t(
          "public.views.Pages.Professional.Admin.Payments.tab.plataform.confirm.nopay.btnCancel"
        ),
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          this.$awn.asyncBlock(
            scheduleService.unpay(this.eventId, this.patientId),
            (response) => {
              if (response) {
                self.getAllEventPlataform();
                self.$bvModal.hide("modal-check-paid-professional");
                self.$notify({
                  group: "notificacions",
                  title: this.$i18n.t(
                    "public.components.schedule.Schedule.notification.title"
                  ),
                  text: this.$i18n.t(
                    "public.components.schedule.Schedule.notification.descUnpayi"
                  ),
                  type: "success",
                });
              }
            },
            (error) => {
              utilsService.auditErrorFrontent({
                info: "scheduleService.unpay",
                module: "view-pages-professional-admin-payments",
                httpStatus: error.response ? error.response.status : null,
                endpoint: window.location.href,
                request: JSON.stringify({
                  eventId: this.eventId, patientId: this.patientId
                })
              });
            },
            " "
          );
        }
      });
    },
    walletPayment() {
      let self = this;

      this.$awn.asyncBlock(
        scheduleService.payCash(this.eventId, this.patientId),
        (response) => {
          if (response) {
            self.getAllEventPlataform();
            self.$bvModal.hide("modal-check-paid-professional");
            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.components.schedule.Schedule.notification.title"
              ),
              text: this.$i18n.t(
                "public.components.schedule.Schedule.notification.descPay"
              ),
              type: "success",
            });
          }
        },
        (error) => {
          self.$swal(
            this.$i18n.t("public.components.schedule.Schedule.errorSwal.text"),
            this.$i18n.t("public.components.schedule.Schedule.errorSwal.text1"),
            this.$i18n.t("public.components.schedule.Schedule.errorSwal.text2")
          );
          utilsService.auditErrorFrontent({
            info: "scheduleService.payCash",
            module: "view-pages-professional-admin-payments",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              eventId: this.eventId, patientId: this.patientId
            })
          });
        },
        " "
      );
    },
  },
  watch: {
    pagination: {
      handler() {
        if (this.start) {
          this.getAllEventPlataform();
        }
        this.start = true;
      },
    },
  },
  data() {
    return {
      isLoadingPatients: false,
      start: false,
      //Put out platform
      eventId: null,
      patientId: null,
      //--
      total: 0,
      pagination: {},
      pageSize: 10,
      currentPage: 1,
      //Search payment platform
      filter: {
        professionals: [],
        patients: [],
        startTo: null,
        startFrom: null,
        price: null,
        paid: null,
        paymentType: null,
        canceled: false
      },

      search: "",
      searchOut: "",

      totalPaid: 0,
      totalPending: 0,

      headers: [
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Admin.Payments.headers.professionals"
          ),
          value: "professionalLead",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Admin.Payments.headers.patients"
          ),
          value: "patients",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Admin.Payments.headers.dateAt"
          ),
          align: "start",
          value: "date",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Admin.Payments.headers.price"
          ),
          value: "price",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Admin.Payments.headers.paid"
          ),
          value: "payment",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Admin.Payments.headers.paymentType"
          ),
          value: "visitType",
        },
        {
          text: "",
          value: "actions",
        },
      ],
      eventsPlataform: [],
      //Payment out platform
      paymentOutPlataforms: [],
      //Select
      paidSelect: PaymentOrNotFilterSelect,
      paymentTypeSelect: PaymentTypeFilterSelect,

      professionalsFilterSelect: [],
      patientsFilterSelect: [],

      user: {},

      //Config date picker
      //vue2-data-picker
      myFormat: "DD/MM/YYYY",
      momentFormat: {
        //[optional] Date to String
        stringify: (date) => {
          return date ? moment(date).format("LL") : "";
        },
        //[optional]  String to Date
        parse: (value) => {
          return value ? moment(value, "LL").toDate() : null;
        },
        //[optional] getWeekNumber
        getWeek: (date) => {
          // a number
        },
      },
    };
  },
  components: {
    DatePicker,
    Multiselect,
  },
};
</script>
